import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'ngx-webstorage';
var RemoveCartItemComponent = /** @class */ (function () {
    function RemoveCartItemComponent(activeModal, localSt) {
        this.activeModal = activeModal;
        this.localSt = localSt;
    }
    RemoveCartItemComponent.prototype.ngOnInit = function () {
        if (this.localSt.retrieve('dateFromRemoveItem')) {
            this.dateFromRemoveItem = this.localSt.retrieve('dateFromRemoveItem');
        }
    };
    RemoveCartItemComponent.prototype.closeModal = function (status) {
        this.localSt.clear('dateFromRemoveItem');
        this.activeModal.close(status);
    };
    return RemoveCartItemComponent;
}());
export { RemoveCartItemComponent };



// WEBPACK FOOTER //
// ./src/app/modules/shared/remove-cart-item/remove.component.ts.pre-build-optimizer.js